// 'exp://192.168.88.214:19000/--/shared'; // expo go url
export const MOBILE_URL = 'geobuyer://--/shared';
